exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".OZ4P-74HjncIZPPMIe1FP {\n  cursor: pointer;\n  pointer-events: all;\n  color: #FFF; }\n\n._K2hZrPaL1ViV8PoFwKqV {\n  cursor: not-allowed;\n  pointer-events: none;\n  color: #FFF;\n  opacity: .8; }\n\n._1-mv6TpMQsZ7SVRwjGyts1 {\n  display: none;\n  visibility: hidden; }\n\n._3M5Ou7Yb--qH26Gz3F-Plp {\n  display: block;\n  width: 30px;\n  height: 30px;\n  color: #FFF; }\n", ""]);

// exports
exports.locals = {
	"uiElementActive": "OZ4P-74HjncIZPPMIe1FP",
	"uiElementInactive": "_K2hZrPaL1ViV8PoFwKqV",
	"uiElementHidden": "_1-mv6TpMQsZ7SVRwjGyts1",
	"svg": "_3M5Ou7Yb--qH26Gz3F-Plp"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/js/standard/global-styles.scss
// module id = 51
// module chunks = 0